import {
  buildPath,
  buildTemplatePath,
  Card,
  CrudMode,
  Dialog,
  handleClose,
  Page,
  PageRoute,
  ScreenType,
  useParams,
  useUnsavedChanges,
  useValidationErrors,
} from "@compass/core";
import {
  Permission,
  SurveyResponseUpdateDto,
} from "generated/openApi";
import "moment-timezone";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ApiService from "services/apiService";
import { SurveyResponseStudentHeader } from "./SurveyResponseStudentHeader";
import { SurveyResponseStudentBody } from "./SurveyResponseStudentBody";

const routeName = "formStudent";

class Params {
  id: number = 0;
  crudMode: CrudMode = "view";
  screenType: ScreenType = "standard";
  deleting: boolean = false;
}

export const surveyResponseStudentPageRoute: PageRoute<Params> = {
  handle: "Student Response",
  templatePath: buildTemplatePath(routeName, Params),
  getPath: (params) => buildPath(routeName, params),
};

export const SurveyResponseStudentPage = () => {
  const ROOT_PERMISSION: Permission = Permission.Form;
  const { params } = useParams(routeName, Params);
  const navigate = useNavigate();
  const [formResponse, setFormResponse] = useState<SurveyResponseUpdateDto>({} as SurveyResponseUpdateDto);
  const { unsavedChanges, resetUnsavedChanges } = useUnsavedChanges({ trackedItems: [formResponse] });
  const { validationErrors, setValidationErrors } = useValidationErrors();

  useEffect(() => {
    fetch(params.id);
  }, []);

  const reroute = (id: number, crudMode: CrudMode) =>
    navigate(
      `../${surveyResponseStudentPageRoute.getPath({ id: id, crudMode: crudMode, screenType: params.screenType, deleting: false })}`
    );

  const fetch = (id: number) => {
    ApiService.surveyResponses.getSurveyResponse(id).then((response) => {
      if (response.formResponse?.personId) {
        ApiService.students.get(response.formResponse?.personId).then((student) => {
          let updateDto: SurveyResponseUpdateDto = { id: response.formResponse!.id, studentId: student.customId1 }
          setFormResponse(updateDto);
          resetUnsavedChanges([response]);
        })
      }
      else {
        let updateDto: SurveyResponseUpdateDto = { id: response.formResponse!.id }
        setFormResponse(updateDto);
        resetUnsavedChanges([response]);
      }
    });
  };

  const pageHeader = (
    <SurveyResponseStudentHeader
      rootPermission={ROOT_PERMISSION}
      handle={surveyResponseStudentPageRoute.handle}
      crudMode={params.crudMode}
      reroute={reroute}      
      fetch={fetch}
      response={formResponse}
      setValidationErrors={setValidationErrors}
      unsavedChanges={unsavedChanges}
      deleting={params.deleting}
    />
  );

  const pageBody = (
    <SurveyResponseStudentBody
      crudMode={params.crudMode}
      formResponse={formResponse}
      setFormResponse={setFormResponse}
      validationErrors={validationErrors}
      deleting={params.deleting}
    />
  );

  return params.screenType === "standard" ? (
    <Page isForm header={pageHeader}>
      <Card>{pageBody}</Card>
    </Page>
  ) : (
    <Dialog
      isForm
      open={true}
      onClose={() => handleClose(navigate, unsavedChanges)}
      maxWidth="md"
      header={pageHeader}
      content={pageBody}
    />
  );
};
